module.exports = __webpack_public_path__ + "static/media/sfx_animal_giraffe.05f041ca.mp3";